import { Injectable } from '@angular/core';
import {
  Country,
  CountryType,
  COUNTRY_NORMALIZER,
  Occ,
  OccSiteAdapter, Region,
  REGION_NORMALIZER, SiteAdapter
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CustomOccSiteAdapter extends OccSiteAdapter implements SiteAdapter {
  loadCountriesAll(type?: CountryType): Observable<Country[]> {
    return this.http
      .get<Occ.CountryList>(
        this.occEndpointsService.buildUrl(
          'countriesAll', {
          queryParams: type ? { type } : undefined,
        })
      )
      .pipe(
        map((countryList) => countryList.countries),
        this.converterService.pipeableMany(COUNTRY_NORMALIZER)
      );
  }

  loadRegionsByZone(countryIsoCode: string, zone?: string): Observable<Region[]> {
    return this.http
      .get<Occ.RegionList>(this.occEndpointsService.buildUrl('regionsZone',
        { urlParams: { isoCode: countryIsoCode, zone: !!zone ? zone : '' } }))
      .pipe(
        map((regionList) => regionList.regions),
        this.converterService.pipeableMany(REGION_NORMALIZER)
      );
  }
}
